export enum IconUsageTypes {
  DECORATIVE = 'decorative',
  STAND_ALONE = 'stand-alone'
}
